import { createControlField } from '@lib/common';
import { blue } from '@material-ui/core/colors';
import styled from 'styled-components';
import { FormControl, InputLabel, Select, FormHelperText } from '@material-ui/core';
import { useFormContext } from 'react-hook-form';

const StatusAutoComplete = ({ value, onChange }) => {
  const form = useFormContext();
  return (
    <Styles>
      <FormControl variant="outlined" size="small" fullWidth>
        <InputLabel id="data_owner_label">Data Owner</InputLabel>
        <Select
          labelId="data_owner_label"
          id="dataowner_id"
          name="dataowner_id"
          inputRef={form.register}
          native
          label="Data Owner"
          defaultValue="Data Owner">
          <option value="4001">DELI</option>
          <option value="1001">TMDB</option>
          <option value="3001">GVD</option>
        </Select>
        <FormHelperText>Data Owner</FormHelperText>
      </FormControl>
    </Styles>
  );
};

const Styles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const DataOwnerField = createControlField(StatusAutoComplete, []);
